import { atom } from 'jotai';

// 通过 $blockDiscussionIds 给内部富文本提供块评论（排除划选评论）数据
export const BLOCK_SCOPE = Symbol('Block Scope');
export const $blockId = atom<string | undefined>(undefined);

export const ROW_SCOPE = Symbol('Row Scope');
export const $rowId = atom<string | undefined>(undefined);
